import { reactive } from 'vue'

export const themeStore = reactive({
  isDark: localStorage.getItem('darkMode') === 'true' || false,

  toggleDarkMode () {
    this.isDark = !this.isDark
    localStorage.setItem('darkMode', this.isDark.toString())
    this.applyTheme()
  },

  setDarkMode (isDark) {
    this.isDark = isDark
    localStorage.setItem('darkMode', isDark.toString())
    this.applyTheme()
  },

  applyTheme () {
    if (this.isDark) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  },

  init () {
    this.applyTheme()
  }
})
